import Button from "@shared/v2/Button";
import dayjs from "@shared/dayjs";
import { AccountProduct, ProductFamily } from "./types";
import Typography from "@shared/v2/Typography";

type ProductFamilyCardProps = {
  onAddAccountProduct: (modalProps: {
    productFamily: ProductFamily;
    accountProduct?: Partial<AccountProduct>;
  }) => void;
  onDeleteAccountProduct: (product: AccountProduct) => void;
  productFamily: ProductFamily;
};

const ProductFamilyCard = ({
  onAddAccountProduct,
  onDeleteAccountProduct,
  productFamily,
}: ProductFamilyCardProps) => (
  <div className="tw-p-[24px] tw-rounded-[8px] tw-shadow-card tw-min-w-[300px] tw-flex tw-flex-col tw-gap-[24px]">
    <h4 className="tw-m-0 tw-font-semibold">{productFamily.typeName}</h4>
    <div className="tw-flex tw-flex-col tw-gap-[24px] tw-justify-start">
      {!productFamily.accountProducts.length && <div>No add-ons of this type.</div>}
      {productFamily.accountProducts.map((accountProduct) => (
        <div
          className="tw-bg-white tw-border-solid tw-border-[1px] tw-border-gray-10 tw-shadow-card tw-p-[12px] tw-rounded-[6px] tw-flex tw-flex-col tw-gap-[8px]"
          key={accountProduct.id}
        >
          {/* @ts-expect-error props */}
          <Typography variant="headline3">{accountProduct.product.name}</Typography>
          {accountProduct.product.details.trackingNumberMax && (
            <span>{accountProduct.product.details.trackingNumberMax} Tracking Numbers</span>
          )}
          {accountProduct.createdAt && (
            <span>Created at: {dayjs(accountProduct.createdAt).format("MM/DD/YYYY")}</span>
          )}
          {accountProduct.startedAt && (
            <span>Started at: {dayjs(accountProduct.startedAt).format("MM/DD/YYYY")}</span>
          )}
          {accountProduct.endedAt && (
            <span>Ends at: {dayjs(accountProduct.endedAt).format("MM/DD/YYYY")}</span>
          )}
          <div className="tw-flex tw-justify-between tw-items-center tw-gap-[16px]">
            {/* @ts-expect-error props */}
            <Button schema="warning" onClick={() => onDeleteAccountProduct(accountProduct)}>
              Delete
            </Button>
            {/* @ts-expect-error props */}
            <Button schema="secondary" onClick={() => onAddAccountProduct({ productFamily, accountProduct })}>
              Edit
            </Button>
          </div>
        </div>
      ))}
    </div>
    <div className="tw-flex tw-justify-center tw-gap-[8px]">
      {/* @ts-expect-error props */}
      <Button onClick={() => onAddAccountProduct({ productFamily })}>+ Add</Button>
    </div>
  </div>
);

export default ProductFamilyCard;
